import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where, } from 'firebase/firestore';
import { auth, db, } from '../firebase';
import { TextField } from '@mui/material';
import moment from 'moment';

export default function Viewpo() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);

    const [podatas, setpodatas] = useState([]);
    const [searchText, setsearchText] = useState("");

    const [updocid, setupdocid] = useState("");



    const [podate, setpodate] = useState(moment().format('YYYY-MM-DD'));
    const [billdate, setbilldate] = useState(moment().format('YYYY-MM-DD'));
    const [toname, settoname] = useState("");
    const [fromname, setfromname] = useState("");
    const [fromaddress, setfromaddress] = useState("");
    const [designation, setdesignation] = useState("");
    const [budgetamount, setbudgetamount] = useState(moment().format(' '));
    const [approveamount, setapproveamount] = useState(moment().format(' '));
    const [subject, setsubject] = useState(" ");



    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);



    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid()
        });
    });

    const fetchPropid = async () => {
        if (userData) {
            if (loadincount) {
                const docRef = doc(db, "users", userData.uid)
                const docSnap = await getDoc(docRef)
                if (docSnap.exists()) {
                    fetchData1();
                    setloadincount(false)
                }
            }
        }
    }

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'poregisters'), where('type', '==', 'Purchase Order'), orderBy('podate', 'desc'))
            onSnapshot(q, (querySnapshot) => {
                setpodatas(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = podatas.filter((item) =>
                item.data.subject.toUpperCase().includes(searchText.toUpperCase())
            );
            setpodatas(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }



    const handleDelete = async (docid) => {
        try {
            // Step 1: Delete related poitems
            const poitemsQuery = query(collection(db, 'poitems'), where("poid", "==", docid));
            const poitemsSnapshot = await getDocs(poitemsQuery);

            const deletePromises = poitemsSnapshot.docs.map((doc) => deleteDoc(doc.ref));

            // Delete all associated poitems
            await Promise.all(deletePromises);

            // Step 2: Delete the poregisters document
            const taskDocRef = doc(db, 'poregisters', docid);
            await deleteDoc(taskDocRef);

            // Step 3: Show success toast and refresh data
            Toast.fire({
                icon: "success",
                title: 'Purchase Order and Related Items Deleted Successfully!!'
            });

            fetchData1();
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: 'Error deleting data. Please try again!'
            });
            console.error("Error deleting data:", error);
        }
    };


    const handleEdit = (id, podate, toname, fromname, fromaddress, designation, billdate, budgetamount, approveamount, subject) => {
        setupdocid(id);
        setpodate(podate)
        setbilldate(billdate)
        settoname(toname)
        setfromname(fromname)
        setfromaddress(fromaddress)
        setdesignation(designation)
        setbudgetamount(budgetamount)
        setapproveamount(approveamount)
        setsubject(subject)
    }

    const handleUpdate = async () => {
        await updateDoc(doc(db, "poregisters", updocid), {
            podate: podate,
            toname: toname,
            fromname: fromname,
            fromaddress: fromaddress,
            designation: designation,
            billdate: billdate,
            budgetamount: budgetamount,
            approveamount: approveamount,
            subject: subject,
        });
        Toast.fire({
            icon: "success",
            title: 'Purchase Order Updated Successfully!!'
        });

        fetchData1();
    }




    return (
        <div>
            <div className="content-wrapper">
                <br />

                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| View Purchase Order ||</button><br /><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className=" p-1">
                                <input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4' placeholder='Type here......' />
                            </div>
                            <div className="card-body table-responsive p-0" >

                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Action</th>
                                            <th>Sr No</th>
                                            <th>Bill To </th>
                                            <th>PO Date </th>
                                            <th>Bill Date </th>
                                            <th>Subject </th>
                                            <th>PO Total </th>
                                            <th>Budget Amount </th>
                                            <th>Approve Amount </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            podatas.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td>
                                                        <a onClick={() => handleEdit(item.id, item.data.podate, item.data.toname, item.data.fromname, item.data.fromaddress, item.data.designation, item.data.billdate, item.data.budgetamount, item.data.approveamount, item.data.subject)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                                                        <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                                                        <a className="btn btn-sm bg-purple" href={'poitem-details/' + item.id} > <i className="fa fa-eye"></i></a>&nbsp;
                                                        <a className="btn btn-sm bg-teal" href={'print-po/' + item.id} > <i className="fa fa-print"></i></a>
                                                    </td>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.data.toname}</td>
                                                    <td>{moment(item.data.podate).format('DD-MM-YYYY')}</td>
                                                    <td>{moment(item.data.billdate).format('DD-MM-YYYY')}</td>
                                                    <td>{item.data.subject}</td>
                                                    <td>{item.data.pototal}</td>
                                                    <td>{item.data.budgetamount}</td>
                                                    <td>{item.data.approveamount}</td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* ============================================= modal start ================================================= */}




            <div className="modal fade" id="text-modal1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Purchase Order</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <div className='card'>
                                        <div className="card-body">
                                            <TextField type='text' className='form-control' value={fromname} onChange={(e) => setfromname(e.target.value)} label="From Name" size='small' /><br /><br />
                                            <TextField type='text' className='form-control' value={fromaddress} onChange={(e) => setfromaddress(e.target.value)} label="From Address" size='small' /><br /><br />
                                            <TextField className='form-control' color="secondary" label="PO Date" type='date' value={podate} onChange={(e) => setpodate(e.target.value)} size='small' /> <br /><br />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-sm-4'>
                                    <div className='card'>
                                        <div className="card-body">
                                            <TextField type='text' className='form-control' value={toname} onChange={(e) => settoname(e.target.value)} label="To Name" size='small' /> <br /><br />
                                            <TextField type='text' className='form-control' value={designation} onChange={(e) => setdesignation(e.target.value)} label="Designation" size='small' /><br /><br />
                                            <TextField className='form-control' color="secondary" label="Bill Date" type='date' value={billdate} onChange={(e) => setbilldate(e.target.value)} size='small' /><br /><br />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-sm-4'>
                                    <div className='card'>
                                        <div className="card-body">
                                            <TextField className='form-control' color="secondary" label="Budget Amount" type='text' value={budgetamount} onChange={(e) => setbudgetamount(e.target.value)} size='small' /><br /><br />
                                            <TextField className='form-control' color="secondary" label="Approval Amount" type='text' value={approveamount} onChange={(e) => setapproveamount(e.target.value)} size='small' /><br /><br />
                                            <TextField type='text' className='form-control' value={subject} onChange={(e) => setsubject(e.target.value)} label="Subject" /><br /><br />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
